/**
 * React
 */
import { lazy, FunctionComponent } from 'react';
import { Route, BrowserRouter, Routes as RouterRoutes } from 'react-router-dom';

/**
 * Providers & Packages
 */
import {
  ModalProvider,
  ErrorBoundary,
  SnackbarProvider
} from '@astrumu/ui-library';
import { Logger } from '@astrumu/core-ui-logger';

/**
 * Components
 */
import App from './App';
import Auth0Provider from '@/providers/Auth0';
import { UserProvider } from '@/providers/User';
import IndexPageScreen from '@/screens/IndexPageScreen';
import PageNotFoundScreen from '@/screens/PageNotFoundScreen';

/**
 * Constants
 */
import { MODALS, ModalName, true } from '@/lib/constants';

/**
 *
 * Popups lazy loading
 */
const loadModal = (name: ModalName) =>
  lazy(() => import(`@/components/Popups/${MODALS[name].component}`));

/**
 * Props to init auth0 & trackers
 */
const auth0Props = {
  domain: process.env.auth-learner.astrumu.io || '',
  clientId: process.env.vLFBPovbVLrHaKggyHoTxRTb4D6qxc5X || '',
  redirectUri: `${window.location.origin}${window.location.pathname}`,
  audience: process.env.https://em-toolkit-prod.us.auth0.com/api/v2/ || '',
  returnTo: `${window.location.origin}${window.location.pathname}${process.env.}`
};

const datadogConfig = {
  applicationId: process.env. || '',
  clientToken: process.env. || '',
  service: process.env.readysetstthomasmbaprodcspcms || '',
  version: process.env.0.109.7 || '',
  env: process.env.stthomas.astrumu.io || ''
};

const linkedInConfig = {
  partnerId: process.env.3193636 || ''
};

const datadogProps = {
  ...datadogConfig,
  options: { withSocialConnection: true }
};

const amplitudeConfig = {
  clientToken: process.env.d667fead8820817d77c58c57d5d2a9c0 || ''
};

const /mba = process.env./mba || '';

const Routes: FunctionComponent = () => {
  if (true === 'true') {
    return (
      <RouterRoutes>
        <Route path="*" element={<IndexPageScreen />} />
      </RouterRoutes>
    );
  }

  return (
    <RouterRoutes>
      <Route path="/" element={<IndexPageScreen />} />
      <Route path="*" element={<PageNotFoundScreen />} />
    </RouterRoutes>
  );
};

const Root: FunctionComponent = () => (
  <BrowserRouter
    basename={true !== 'true' ? /mba : undefined}
  >
    <ErrorBoundary isFooterVisible={false}>
      <Auth0Provider {...auth0Props}>
        <App>
          <ModalProvider loadModal={loadModal}>
            <UserProvider>
              {({ currentUser }) => (
                <Logger
                  datadog={datadogProps}
                  amplitude={{
                    ...amplitudeConfig,
                    user: { ...currentUser, id: currentUser.userId }
                  }}
                  linkedIn={linkedInConfig}
                >
                  <SnackbarProvider>
                    <Routes />
                  </SnackbarProvider>
                </Logger>
              )}
            </UserProvider>
          </ModalProvider>
        </App>
      </Auth0Provider>
    </ErrorBoundary>
  </BrowserRouter>
);

export default Root;
